import React from 'react';
import TableStyle from './TableStyle';
import { Card, Row } from 'react-bootstrap';

const TableStyleGroup = ({ dashboardGroup }) => {
    let tableDetails = dashboardGroup && dashboardGroup.Details && dashboardGroup.Details || [];
    if (!dashboardGroup && dashboardGroup.GroupType !== 'TableStyle' && tableDetails.length === 0) return null;
    return (
        <TableStyle itemDetail={dashboardGroup} />

    );

};

export default TableStyleGroup;

